import { LogIn, LogOut } from "lucide-react";
import { type User } from "../services/api";
import { type Language } from "../types/siteContent";

const canvasRuntimeVersion = "20260806-174200";

export function CanvasPage(props: {
  language: Language;
  isReady: boolean;
  isAuthenticated: boolean;
  isCanvasAuthenticated: boolean;
  user: User | null;
  onAuthOpen: () => void;
  onLogout: () => void;
  onBackHome: () => void;
}) {
  if (!props.isReady) {
    return (
      <main className="canvas-auth-shell">
        <section className="canvas-auth-card">
          <h1>{props.language === "en" ? "Loading canvas..." : "\u6b63\u5728\u52a0\u8f7d\u753b\u5e03..."}</h1>
        </section>
      </main>
    );
  }

  if (!props.isAuthenticated) {
    return (
      <main className="canvas-auth-shell">
        <section className="canvas-auth-card">
          <LogIn size={30} />
          <h1>{props.language === "en" ? "Sign in to open Canvas" : "\u767b\u5f55\u540e\u4f7f\u7528\u529f\u80fd\u753b\u5e03"}</h1>
          <p>
            {props.language === "en"
              ? "Your canvas documents are saved to your MAIPO account."
              : "\u4f60\u7684\u753b\u5e03\u4f1a\u4fdd\u5b58\u5230\u5f53\u524d MAIPO \u8d26\u53f7\u4e0b\u3002"}
          </p>
          <button className="button button-primary" type="button" onClick={props.onAuthOpen}>
            {props.language === "en" ? "Sign in" : "\u767b\u5f55"}
          </button>
        </section>
      </main>
    );
  }

  if (!props.isCanvasAuthenticated) {
    return (
      <main className="canvas-auth-shell">
        <section className="canvas-auth-card">
          <LogIn size={30} />
          <h1>{props.language === "en" ? "Sign in again to open Canvas" : "\u8bf7\u91cd\u65b0\u767b\u5f55\u540e\u4f7f\u7528\u529f\u80fd\u753b\u5e03"}</h1>
          <p>
            {props.language === "en"
              ? "Canvas requires a fresh browser-session sign-in so another person cannot reopen your workspace after the browser is closed."
              : "\u529f\u80fd\u753b\u5e03\u9700\u8981\u5f53\u524d\u6d4f\u89c8\u5668\u4f1a\u8bdd\u5185\u91cd\u65b0\u767b\u5f55\uff0c\u907f\u514d\u4e0b\u6b21\u6253\u5f00\u65f6\u76f4\u63a5\u8fdb\u5165\u4e0a\u4e00\u4e2a\u8d26\u53f7\u3002"}
          </p>
          <button className="button button-primary" type="button" onClick={props.onAuthOpen}>
            {props.language === "en" ? "Sign in again" : "\u91cd\u65b0\u767b\u5f55"}
          </button>
        </section>
      </main>
    );
  }

  const frameUrl = `/canvas-web/index.html?v=${canvasRuntimeVersion}&lang=${encodeURIComponent(props.language)}&user=${encodeURIComponent(props.user?.id || "")}`;

  return (
    <main className="canvas-page-shell">
      <button className="canvas-session-logout" type="button" onClick={props.onLogout}>
        <LogOut size={15} />
        {props.language === "en" ? "Switch account" : "\u9000\u51fa / \u5207\u6362\u8d26\u53f7"}
      </button>
      <iframe
        key={props.user?.id || "canvas"}
        className="canvas-runtime-frame"
        src={frameUrl}
        title="MAIPOAI Canvas"
        allow="clipboard-read; clipboard-write"
      />
    </main>
  );
}
